import { Icon, type IconProps } from "@iconify/react";
import { Box, BoxProps } from "@mui/material";
import { forwardRef } from "react";

export type IconifyProps = BoxProps & IconProps;

const iconifyClasses = {
  flag: "mnl__icon__flag",
  root: "mnl__icon__root",
};

export const Iconify = forwardRef<SVGElement, IconifyProps>(function Iconify(
  { className, sx, width = 20, ...other },
  ref,
) {
  return (
    <Box
      className={iconifyClasses.root.concat(className ? ` ${className}` : "")}
      component={Icon}
      ref={ref}
      ssr
      sx={{
        display: "inline-flex",
        flexShrink: 0,
        height: width,
        width,
        ...sx,
      }}
      {...other}
    />
  );
});

// // https://iconify.design/docs/iconify-icon/disable-cache.html
// disableCache("local");
